import axios from "axios";
import router from "@/router";

import ElementUI from "element-ui";
import { Loading } from "element-ui";
import AES from "./ASE";
import EDC from "./dec";
import QS from "qs";
import Vue from "vue";
import store from "../store";
import { error } from "jquery";
const server = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API,
  timeout: 40000, // 请求超时时间
});
// 记录正在进行的请求
let pending = 0;
let loadingInstance1;
// 添加一个请求拦截器
server.interceptors.request.use(
  (config) => {
    pending++;
    //统一设置请求头部信息
    config.headers["Content-Type"] = "application/json";
    config.headers["Authorization"] = localStorage.getItem("token");
    //判断请求方式是post还是get
    if (!config.noloading) {
      loadingInstance1 = Loading.service({
        customClass: "foshoLoading",
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "#be3c6e00",
      });
    }
    if (config.method === "post" || config.method === "put") {
      config.data = QS.parse(config.data);
      if (window.location.origin === "https://www.foshoaff.com") {
        var datas = {
          d: AES.encrypt(JSON.stringify(config.data)),
        };
        config.data = datas;
      }
    }
    if (config.method === "get") {
      config.params = { ...config.params };
      config.params = QS.parse(QS.stringify(config.params));
    }
    //数据根据请求方式进行拼接发送给后台
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 添加一个响应拦截器
server.interceptors.response.use(
  (res) => {
    if (res.data.code == "success") {
      if (window.location.origin === "https://www.foshoaff.com") {
        res.data.body = JSON.parse(EDC.decrypt(res.data.body));
      } else {
        res.data.body = res.data.body;
      }
    } else if (res.data.code == "error") {
      // this.$message.error(res.data.msg)
    }
    if (res && res.data.code) {
      switch (res.data.code) {
        case "nolog":
          localStorage.clear();
          router.push({ path: "/" });
          // ElementUI.Message({
          //   type: 'error',
          //   message: '账号在其他地方登录,您被迫下线'
          // })
          break;
        case "forceout":
          ElementUI.MessageBox.confirm(
            "您的账号在另一地点登录，被迫下线，账号有泄露密码的风险，请重新登录或修改密码",
            {
              confirmButtonText: "确定",
              showCancelButton: false,
              type: "warning",
            }
          )
            .then(() => {
              localStorage.clear();
              router.push({ path: "/" });
            })
            .catch(() => {});
          break;
        case 403:
      }
    }
    pending--;
    setTimeout(() => {
      if (pending <= 0) {
        loadingInstance1.close();
      }
    }, 30);
    return res;
  },
  (err) => {}
);
try {
} catch (err) {
  loadingInstance1.close();
}

export default server;
